import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { noop } from 'utils'

import Box from '@mui/material/Box'

import { ORDER, SORT } from './constants'

function RankingsBoxTableHeader({ hideFlag, indicator, onSort = noop, sort, title }) {
  const { t: translate } = useTranslation()

  return (
    <div className="rankings-box-table-header">
      <div className="row-wrapper flex-row">
        <Box
          className={classNames('cell cell-noLY cursor-pointer', {
            active: sort.sortBy === SORT.RANK,
            asc: sort.order === ORDER.ASC,
          })}
          onClick={() => onSort(SORT.RANK)}
        >
          {translate('rankings.pos')}
        </Box>

        <Box
          className={classNames('cell cell-title flex-row cursor-pointer', {
            active: sort.sortBy === SORT.TITLE,
            asc: sort.order === ORDER.ASC,
          })}
          onClick={() => onSort(SORT.TITLE)}
        >
          <div className={classNames('flag', { 'hide-flag': hideFlag })} />
          {title}
        </Box>

        <Box
          className={classNames('cell cell-indicator cursor-pointer', {
            active: sort.sortBy === SORT.INDICATOR,
            asc: sort.order === ORDER.ASC,
          })}
          onClick={() => onSort(SORT.INDICATOR)}
        >
          {translate(`rankings.${indicator}`)}
        </Box>
      </div>
    </div>
  )
}

RankingsBoxTableHeader.propTypes = {
  hideFlag: PropTypes.bool,
  indicator: PropTypes.string,
  onSort: PropTypes.func,
  sort: PropTypes.shape({
    order: PropTypes.oneOf([ORDER.ASC, ORDER.DESC]),
    sortBy: PropTypes.string,
  }),
  title: PropTypes.string,
}

export default RankingsBoxTableHeader
